import { gql } from "@apollo/client";

export const MAINTAIN_FEED_CURVE = gql`
  mutation Maintain($domain: String!, $maintainFeedCurve: MaintainFeedCurve!) {
    feedCurve {
      maintain(domain: $domain, maintainFeedCurve: $maintainFeedCurve)
    }
  }
`
export type MaintainFeedCurveResponse = {
  feedCurve: {
    maintain: number;
  }
}

export type MaintainFeedCurveVariables = {
  domain: string
  maintainFeedCurve: MaintainFeedCurve
}

export type MaintainFeedCurve = {
  creates?: MaintainFeedCurveCreates;
  deletes?: MaintainFeedCurveDelete;
  feedCurveId: number;
  updates?: MaintainFeedCurveUpdates;
};

type MaintainFeedCurveCreateComponent = {
  component_id: number;
  gram_per_minute: number;
  temporaryId: number;
};

type MaintainFeedCurveCreateDayComponent = {
  amount: number;
  component_id: number;
  temporaryId: number;
};

type MaintainFeedCurveCreateFeedDay = {
  /** Day to create needed if dayId is null */
  day: number;
  /** Any new components to create for the specific day */
  dayComponents?: Array<MaintainFeedCurveCreateDayComponent>;
  dayId?: number;
  temporaryId: number;
};

type MaintainFeedCurveCreateFeedPlan = {
  amount: number;
  day: number;
  time_id: number;
  temporaryId: string;
};

type MaintainFeedCurveCreateMilestone = {
  feedCurveMilestoneId?: number;
  feedDays?: Array<MaintainFeedCurveCreateFeedDay>;
  feedPlan?: Array<MaintainFeedCurveCreateFeedPlan>;
  /** Id for the feed curve milestone */
  milestone_id: number;
  milestone_index: number;
  temporaryId: number;
};

type MaintainFeedCurveCreateTime = {
  time?: number;
  time_id: number;
};

/** Object containing (possibly nested) feed curve entries to create */
export type MaintainFeedCurveCreates = {
  components?: Array<MaintainFeedCurveCreateComponent>;
  milestones?: Array<MaintainFeedCurveCreateMilestone>;
  times?: Array<MaintainFeedCurveCreateTime>;
};

/** Object containing the list of different feed curve entires to delete */
export type MaintainFeedCurveDelete = {
  /** Feed curve components to delete -- warning does not remove the individual dayComponents */
  components?: Array<number>;
  /** Feed day components to delete (removal of the individual components for a given day) */
  dayComponents?: Array<number>;
  /** Feed days to delete */
  feedDays?: Array<number>;
  /** Feed plan entries to delete */
  feedPlan?: Array<number>;
  /** Milestones to delete */
  milestones?: Array<number>;
  /** Feeding times to delete */
  times?: Array<number>;
};

/** Changes corresponding to base feed curve info */
type MaintainFeedCurveUpdateBaseInfo = {
  feed_limit?: number;
  name?: string;
  pass_feed?: number;
  stimuli?: number;
};

export type MaintainFeedCurveUpdateComponent = {
  baseInfo: MaintainFeedCurveUpdateComponentBaseInfo;
  feedCurveComponentId: number;
};

type MaintainFeedCurveUpdateComponentBaseInfo = {
  component_id?: number;
  gram_per_minute?: number;
};

export type MaintainFeedCurveUpdateDayComponent = {
  baseInfo: MaintainFeedCurveUpdateDayComponentBaseInfo;
  dayComponentId: number;
};

type MaintainFeedCurveUpdateDayComponentBaseInfo = {
  amount?: number;
  fk_components?: number;
};

type MaintainFeedCurveUpdateFeedDay = {
  baseInfo: MaintainFeedCurveUpdateFeedDayBaseInfo;
  dayId: number;
};

type MaintainFeedCurveUpdateFeedDayBaseInfo = {
  day?: number;
};

type MaintainFeedCurveUpdateFeedPlan = {
  baseInfo: MaintainFeedCurveUpdateFeedPlanBaseInfo;
  feedPlanEntryId: number;
};

type MaintainFeedCurveUpdateFeedPlanBaseInfo = {
  amount?: number;
  day?: number;
  timeId?: number;
};

type MaintainFeedCurveUpdateMilestone = {
  baseInfo: MaintainFeedCurveUpdateMilestoneBaseInfo;
  feedCurveMilestoneId: number;
};

type MaintainFeedCurveUpdateMilestoneBaseInfo = {
  milestone_id?: number;
  milestone_index?: number;
};

/** Changes corresponding to feed plan times */
type MaintainFeedCurveUpdateTime = {
  baseInfo: MaintainFeedCurveUpdateTimeBaseInfo;
  /** Id for the time to update */
  timeId: number;
};

type MaintainFeedCurveUpdateTimeBaseInfo = {
  /** Time stamp */
  time?: number;
};

export type MaintainFeedCurveUpdates = {
  baseInfo?: MaintainFeedCurveUpdateBaseInfo;
  components?: Array<MaintainFeedCurveUpdateComponent>;
  dayComponents?: Array<MaintainFeedCurveUpdateDayComponent>;
  feedDays?: Array<MaintainFeedCurveUpdateFeedDay>;
  feedPlan?: Array<MaintainFeedCurveUpdateFeedPlan>;
  milestones?: Array<MaintainFeedCurveUpdateMilestone>;
  times?: Array<MaintainFeedCurveUpdateTime>;
};